export default __webpack_public_path__ + "static/clouds-close-6f5487e0796da9d22c7f4b1a8a138bbc.svg";